module.exports = __webpack_public_path__ + "static/media/logo_leibniz_en.13637f38.svg";